import styled, {css} from 'styled-components'

export const StyledUserPrivacyFromWrapper = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: ${spacing * 4}px;
        width: 100%;
    `
)

export const StyledUserPrivacyTitle = styled.p(
    ({theme: {typography}}) => css`
        ${typography.textSm};
        font-weight: 500;
    `
)

export const StyledUserPrivacySubTitle = styled.p(
    ({theme: {typography}}) => css`
        ${typography.textSm};
        font-weight: 400;
    `
)
